import {createElement} from 'react'
import {pick, omit} from 'lodash-es'

const withInnerWrapper = (InnerComponent, acceptPropNames = []) => (WrapperComponent) => ({children, ...restProps}) => {
  const wrapperComponentProps = omit(restProps, acceptPropNames)
  const innerComponentProps = pick(restProps, acceptPropNames)

  return createElement(
    WrapperComponent,
    wrapperComponentProps,
    createElement(
      InnerComponent,
      innerComponentProps,
      children,
    ),
  )
}

export default withInnerWrapper
